import { render } from "./IndexO.vue?vue&type=template&id=82c595a4"
import script from "./IndexO.vue?vue&type=script&lang=js"
export * from "./IndexO.vue?vue&type=script&lang=js"

import "./IndexO.vue?vue&type=style&index=0&id=82c595a4&lang=css"

import exportComponent from "/Users/saleem/Sites/unitedtours/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__